<template>
  <div class="search-dialog" @click="isDialogShow = false">
    <div class="dialog-root" :class="{ 'change-flex': searchFlag }">
      <div class="bg">

      </div>
      <img
        class="close"
        src="~@/assets/images/close.svg"
        @click.stop="closeSearchDialog"/>

      <div class="search">
        <div class="search-title" v-show="!searchFlag">
          {{ $t('messages.searchTitle') }}
        </div>

        <div
          class="search-second-title regular" v-show="!searchFlag">
            {{ $t('messages.searchSecondTitle') }}
        </div>


        <div class="search-menu">
          <div
            class="search-input"
            :class="{ 'no-text-border': !searchText, 'change-width': searchFlag }">
              <img
                class="icon-search"
                :class="{ 'no-text': !searchText }"
                src="~@/assets/images/search.svg">
              <input
                type="text"
                ref="searchInput"
                class="input regular"
                placeholder="请输入检索关键词"
                :class="{ 'no-text': !searchText }"
                @keydown.enter="searchMessages(searchMessagesType)"
                v-model="searchText">
              <img
                class="clear"
                v-show="searchText"
                src="~@/assets/images/close_fill.svg"
                @click.stop="searchText = ''"/>
          </div>

          <div
            class="search-button"
            v-if="!searchFlag"
            @click.stop="searchMessages('all')">
              {{ $t('messages.searchButton') }}
          </div>
        </div>

      </div>

      <div
        class="search-messages"
        v-show="searchFlag">

          <div
            class="search-menu">

              <div class="search-messages-num">
                检索结果 {{ searchNum }} 条
              </div>

              <div class="search-messages-type regular">
                分类：&nbsp;
                  <div
                    class="type"
                    ref="type"
                    @click.stop="dialogShow">
                      {{ $i18n.locale === 'zh-CN' ? searchTypeName.cn : searchTypeName.en }}
                      <img class="arrow-donw" src="~@/assets/images/arrow.svg">
                  </div>
              </div>

          </div>

          <div class="list">
            <div
              class="search-messages-item"
              :class="{ 'list-margin': index === 0 }"
              v-for="(message, index) in searchSA.articles"
              :key="index"
              @mouseover="hoverIndex = index"
              @mouseout="hoverIndex = -1">

                <transition name="background-show">
                  <div class="item-bg" v-show="hoverIndex === index"></div>
                </transition>

                <div class="messages-type regular">{{ judgeCategory(message.category) }}</div>

                <div class="messages-info">
                <div class="messages-title">
                  <div class="text regular">
                    {{ $i18n.locale === 'zh-CN' ? message.article.title : message.article.title_en }}
                  </div>

                  <transition name="background-show">
                    <div
                      class="messages-button"
                      @click.stop="learnMore(message)"
                      v-show="hoverIndex === index">
                        {{ $t('messages.scienceMessagesButton') }}
                    </div>
                  </transition>

                </div>
                <div class="messages-date">{{ formDate(message.article.updatedAt) }}</div>
              </div>


            </div>

            <div
              class="search-messages-item"
              :class="{ 'list-margin': index === 0 }"
              v-for="(message, index) in searchSA.leaders"
              :key="message.createdAt"
              @mouseover="hoverLeader = index"
              @mouseout="hoverLeader = -1">

                <transition name="background-show">
                  <div class="item-bg" v-show="hoverLeader === index"></div>
                </transition>

                <div class="messages-type regular">{{ judgeCategory('leaders') }}</div>

                <div class="messages-info">
                <div class="messages-title">
                  <div class="text regular">
                    {{ $i18n.locale === 'zh-CN' ? message.name : message.name }}
                  </div>

                  <transition name="background-show">
                    <div
                      class="messages-button"
                      @click.stop="learnMore(message)"
                      v-show="hoverLeader === index">
                        {{ $t('messages.scienceMessagesButton') }}
                    </div>
                  </transition>

                </div>
                <div class="messages-date">{{ formDate(message.updatedAt) }}</div>
              </div>
            </div>

            <div
              class="search-messages-item"
              :class="{ 'list-margin': index === 0 }"
              v-for="(message, index) in searchSA.teachers"
              :key="index"
              @mouseover="hoverTeacher = index"
              @mouseout="hoverTeacher = -1">

                <transition name="background-show">
                  <div class="item-bg" v-show="hoverTeacher === index"></div>
                </transition>

                <div class="messages-type regular">{{ judgeCategory('teacher') }}</div>

                <div class="messages-info">
                  <div class="messages-title">
                    <div class="text regular">
                      {{ $i18n.locale === 'zh-CN' ? message.name : message.name }}
                    </div>

                    <transition name="background-show">
                      <div
                        class="messages-button"
                        @click.stop="learnMore(message)"
                        v-show="hoverTeacher === index">
                          {{ $t('messages.scienceMessagesButton') }}
                      </div>
                    </transition>

                  </div>
                  <div class="messages-date">{{ formDate(message.updatedAt) }}</div>
                </div>
            </div>
          </div>

      </div>

      <transition name="dialog-show">
        <div
          class="dialog"
          v-show="isDialogShow"
          :style="`top: ${dialogTop}px; left: ${dialogLeft}px`">

            <div
              class="option semibold"
              :class="{ 'select-option': searchMessagesType === option.type }"
              v-for="(option, index) in dialogOptions"
              :key="index"
              @click.stop="selectOption(option)">
                {{ $i18n.locale === 'zh-CN' ? option.name : option.name_en }}
            </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { getLang, formDate } from '@/utils'

export default {
  data() {
    return {
      searchText: '',
      searchMessagesShow: true,
      searchErr: false,
      searchFlag: false,
      searchMessagesType: 'all',
      searchTypeName: {
        cn: '全部',
        en: 'all'
      },
      isDialogShow: false,
      dialogTop: 0,
      dialogLeft: 0,
      hoverIndex: -1,
      hoverLeader: -1,
      hoverTeacher: -1,
      lang: this.$i18n.locale,
      dialogOptions: [
        {
          name: '全部',
          name_en: 'all',
          type: 'all'
        },
        {
          name: '研究院概况',
          name_en: 'About',
          type: 'leader'
        },
        {
          name: '师资队伍',
          name_en: 'Faculty',
          type: 'teacher'
        },
        {
          name: '新闻通告',
          name_en: 'News and announcement',
          type: 'information',
        },
        {
          name: '人才培养',
          name_en: 'Cultivate',
          type: 'cultivate',
        },
        {
          name: '科学研究',
          name_en: 'Research',
          type: 'science'
        }
      ],
      searchNum: 0,
    }
  },

  watch: {
    lang(val) {
      if (val === 'zh-CN') {
        this.changeLangEN()
      } else {
        this.changeLangCN()
      }
    },

    searchText() {
      if (!this.searchFlag) {
        return
      }

      this.SEARCH_SA({
        result: {},
        word: ''
      })

      if (this.searchText && this.searchText.trim().length !== 0) {
        this.searchScienceArticle({
          category: this.searchMessagesType,
          word: this.searchText,
        })
      }
    },

    searchSA: {
      handler() {
        const articles = this.searchSA.articles ? this.searchSA.articles.length : 0
        const leaders = this.searchSA.leaders ? this.searchSA.leaders.length : 0
        const teachers = this.searchSA.teachers ? this.searchSA.teachers.length : 0
        this.searchNum = articles + leaders + teachers
      }
    }
  },

  computed: {
    ...mapState('home', [
      'isSearch',
      'searchSA'
    ]),
  },

  mounted() {
    this.$refs.searchInput.focus();
  },

  methods: {
    ...mapActions('home', [
      'searchScienceArticle'
    ]),

    ...mapMutations('home', [
      'SETUP_IS_SHEARCH',
      'SEARCH_SA'
    ]),

    getLang,
    formDate,

    changeLangCN() {
      switch (this.lang) {
        case 'all': {
          this.lang = '全部'
          break;
        }

        case 'About': {
          this.lang = '研究院概况'
          break;
        }

        case 'Faculty': {
          this.lang = '师资队伍'
          break;
        }

        case 'Dynamic information': {
          this.lang = '新闻通告'
          break;
        }

        case 'Cultivate': {
          this.lang = '人才培养'
          break;
        }

        case 'Research': {
          this.lang = '科学研究'
          break;
        }

        default:
          this.lang = '全部'
          break;
      }
    },

    changeLangEN() {
      switch (this.lang) {
        case '全部': {
          this.lang = 'all'
          break;
        }

        case '研究院概况': {
          this.lang = 'About'
          break;
        }

        case '师资队伍': {
          this.lang = 'Faculty'
          break;
        }

        case '新闻通告': {
          this.lang = 'Dynamic information'
          break;
        }

        case '人才培养': {
          this.lang = 'Cultivate'
          break;
        }

        case '科学研究': {
          this.lang = 'Research'
          break;
        }

        default:
          this.lang = 'all'
          break;
      }
    },

    searchMessages(type) {
      if (this.searchText && this.searchText.trim().length !== 0) {
        this.searchScienceArticle({
          category: type,
          word: this.searchText,
        })

        this.searchFlag = true
      }
    },

    closeSearchDialog() {
      this.SETUP_IS_SHEARCH({
        type: false,
      })
      this.SEARCH_SA({
        result: {},
        word: ''
      })
      this.searchFlag = false
      this.searchText = ''
    },

    judgeCategory(category) {
      let type = ''
      switch (category) {
        case 'ResearchDirection': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科学方向'
          } else {
            type = 'Research / Research directions'
          }
          break;
        }

        case 'CultivateManage': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '人才培养 / 吴文俊人工智能荣誉博士班'
          } else {
            type = 'Cultivate / Postgraduate cultivation'
          }
          break;
        }

        case 'ResearchAwards': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'Notice': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 通知公告'
          } else {
            type = 'News and announcement / Announcement'
          }
          break;
        }

        case 'News': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 新闻信息'
          } else {
            type = 'News and announcement / News'
          }
          break;
        }

        case 'Learning': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 学术动态'
          } else {
            type = 'News and announcement / Academic development'
          }
          break;
        }

        case 'Employment': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 招聘信息'
          } else {
            type = 'News and announcement  /  Job Offers'
          }
          break;
        }

        case 'MajorAchievements': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'ResearchProjects': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'ResearchLightspot': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'leaders': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '研究院概况 / 研究院领导'
          } else {
            type = 'About / AI Institute leadership'
          }
          break;
        }

        case 'teacher': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '师资队伍'
          } else {
            type = 'Faculty'
          }
          break;
        }

        default:
          break;
      }

      return type
    },

    learnMore(message) {
      switch (message.category) {
        case 'ResearchDirection': {
          window.open('/research/directions')
          break;
        }

        case 'ResearchAwards': {
          // window.open(`/research/results-detail/award/${message.id}`)
          window.open('/research/results/award')
          break;
        }

        case 'ResearchProjects': {
          // window.open(`/research/results-detail/project/${message.id}`)
          window.open('/research/results/project')
          break;
        }

        case 'MajorAchievements': {
          // window.open(`/research/results-detail/result/${message.id}`)
          window.open('/research/results/important')
          break;
        }

        case 'ResearchLightspot': {
          // window.open(`/research/results-detail/paper/${message.id}`)
          window.open('/research/results/paper')
          break;
        }

        case 'CultivateManage': {
          window.open(`/cultivate/postgraduate/managements/${message.id}`)
          break;
        }

        case 'Learning': {
          window.open(`/info/academic/${message.id}`)
          break;
        }

        case 'Notice': {
          window.open(`/info/announcements/${message.id}`)
          break;
        }

        case 'News': {
          window.open(`/info/news/${message.id}`)
          break;
        }

        case 'Employment': {
          window.open(`/info/jobs/${message.id}`)
          break;
        }

        case 'leaders': {
          window.open('/about/leaders')
          break
        }

        case 'teachers': {
          window.open(`/faculty/detail/${message.id}`)
          break
        }

        default:
          break;
      }
    },

    dialogShow() {
      this.isDialogShow = !this.isDialogShow
      const type = this.$refs.type
      this.dialogTop = type.offsetTop + 260
      this.dialogLeft = type.offsetLeft - 148
    },

    selectOption(option) {
      this.searchMessagesType = option.type
      this.searchTypeName.cn = option.name
      this.searchTypeName.en = option.name_en
      this.isDialogShow = false
      this.searchScienceArticle({
        category: this.searchMessagesType,
        word: this.searchText,
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/dialog-transition';
@import '~@/styles/font';

@keyframes messagesShow
{
  0% {
    opacity: 0;
    transform: translateY(30px);
    height: calc(~'100vh - 230px');
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
    height: calc(~'100vh - 230px');
  }
}

.search-dialog {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1002;
}

.dialog-root {
  height: 100%;
  width: 100%;
  // background-image: linear-gradient(44deg, rgba(31,37,62,0.80) 0%, rgba(21,25,59,0.80) 100%, #1D2352 100%);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.change-flex {
  justify-content: flex-end;

  .search {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .search-menu {
      margin-left: 0;
    }
  }
}

.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #0e1117;
  opacity: 0.8;
  // background-image: radial-gradient(84% 124%, rgba(69,45,129,0.50) 21%, rgba(31,37,62,0.00) 100%);
  z-index: 2;
  animation: bgShow 0.8s
}

@keyframes bgShow
{
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes titleShow
{
  0% { transform: translateY(30px); opacity: 0; }
  100% { transform: translateY(0px); opacity: 1; }
}

.close {
  position: absolute;
  height: 21.2px;
  width: 21.2px;
  color: white;
  top: 27px;
  right: 115px;
  cursor: pointer;
  z-index: 3;
}

.search {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
  padding-bottom: 16px;

  .search-title {
    // font-size: 32px;
    text-shadow: 0 2px 6px rgba(0,0,0,0.20);
    color: white;
    cursor: default;
    opacity: 0;
    animation: titleShow .3s ease-out;
    animation-delay: 0.3s;
    animation-fill-mode : forwards;
    font-weight: 500;
    font-size: 36px;
    letter-spacing: 0;
    text-align: center;
    line-height: 36px;
  }

  .search-second-title {
    font-size: 18px;
    color: white;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    text-shadow: 0 2px 6px rgba(0,0,0,0.20);
    margin-top: 20px;
    margin-bottom: 60px;
    opacity: 0;
    animation: titleShow .35s ease-out;
    animation-delay: 0.4s;
    animation-fill-mode : forwards;
  }

  .search-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    animation: titleShow .45s ease-out;
    animation-delay: 0.5s;
    animation-fill-mode : forwards;
    opacity: 0;
    margin-left: 60px;
  }

  .search-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid rgba(255, 255, 255, 0.8);
    width: 680px;
    color: white;
    height: 50px;

    .icon-search {
      font-size: 24px;
      margin-right: 16px;
      opacity: 0.8;
    }

    .no-text {
      opacity: 0.5;
    }

    .input {
      height: 24px;
      font-size: 18px;
      width: 95%;
      background: transparent;
      color: white;
      margin-right: 20px;
      letter-spacing: 0;
      line-height: 24px;
      margin-bottom: 2px;
    }

    ::-ms-clear,
    ::-ms-reveal{
      display: none;
    }

    .clear {
      height: 20px;
      width: 20px;
      cursor: pointer;
      opacity: 0.3;
    }
  }

  .no-text {
    opacity: 0.5;
  }

  .no-text-border {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .tips {
    margin-top: 45px;
    color: red;
    font-size: 14px;
  }

  .search-button {
    background-image: linear-gradient(130deg, #AB258B 0%, #7B44EA 100%);
    border-radius: 2px;
    height: 50px;
    width: 140px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    border-radius: 2px;
    animation: titleShow .55s ease-out;
    animation-delay: 0.65s;
    animation-fill-mode : forwards;
    opacity: 0;
    font-weight:500;
    font-size: 18px;
    letter-spacing: 2px;
    text-align: center;
    line-height: 18px;
    margin-left: 20px;
  }
}

.change-width {
  padding-bottom: 0px;
  animation: changeSearchWidth 1s;
  animation-fill-mode : forwards;
  width: e("calc(100vw - 280px)");
  padding-bottom: 4px;

  .input {
    width: 100%;
  }

  .search-title {
    display: none;
  }

  .search-second-title {
    display: none;
  }
}

@keyframes changeSearchWidth
{
  0% {
    width: 560px;
    transform: translateY(300px);
  }

  50% {
    width: e("calc(100vw - 280px)");
    transform: translateY(300px);
  }

  100% {
    width: e("calc(100vw - 280px)");
    transform: translateY(0px);
  }
}

.dialog {
  width: 200px;
  background: rgba(18,25,39, 0.9);
  border-radius: 2px;
  z-index: 6;
  position: absolute;
  margin-top:10px;
  padding:8px 0;

  .option {
    width: 100%;
    height: 46px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: white;
    opacity: 0.7;
    cursor: pointer;
    padding: 0 20px;

    &:hover{
      background-color: rgba(0,0,0,.3);
    }

  }

  .select-option {
    opacity: 1;
  }
}



.search-messages {
  display: flex;
  flex-direction: column;
  z-index: 3;
  height: calc(~'100vh - 230px');
  margin-top: 60px;
  align-items: center;
  width: 100%;
  animation: messagesShow 1s;
  animation-delay: 1s;
  animation-fill-mode : forwards;
  opacity: 0;

  .search-menu {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding-bottom: 22px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    width: e("calc(100% - 280px)");

    .search-messages-num {
      font-size: 14px;
      color: white;
      opacity: 0.7;
      
      letter-spacing: 0;
      line-height: 14px;
    }

    .search-messages-type {
      font-size: 14px;
      color: white;
      opacity: 0.7;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: default;

      .type {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .arrow-donw {
        height: 20px;
        width: 20px;
        margin-left: 4px;
      }
    }
  }
}

.list {
  display: flex;
  flex-direction: column;
  // height: calc(~'100%');
  height: 100%;
  width: 100%;
  overflow-y: auto;
}

.search-messages-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  height: 84px;
  z-index: 4;

  .messages-type {
    color: white;
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 10px;
    z-index: 3;
    padding-left: 140px;
    opacity: 0.7;
    letter-spacing: 0;
    line-height: 14px;
  }

  .messages-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 3;
    padding: 0 140px;

    .messages-title {
      font-size: 16px;
      line-height: 16px;
      height: 24px;
      width: calc(~'100% - 140px');
      color: white;
      display: flex;
      flex-direction: row;
      align-items: center;

      .text {
        max-width: 80%;
        word-break: break-all;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: default;
      }

      .messages-button {
        border: 1px solid white;
        border-radius: 2px;
        width: 66px;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 18px;
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 2px;
        text-align: center;
        line-height: 14px;

        &:hover{
          background: white;
          color: #9236BF;
        }
      }
    }

    .messages-date {
      font-size: 14px;
      color: white;
      opacity: 0.7;
      
      line-height: 14px;
      letter-spacing: 0;
      margin-right: 25px;
    }
  }

  .item-bg {
    position: absolute;
    background-image: linear-gradient(30deg, #AB258B 0%, #7B44EA 100%);
    height: 100%;
    width: 100%;
    z-index: 2;
  }
}

.list-margin {
  margin-top: 23px;
}
</style>



// WEBPACK FOOTER //
// search.vue?3caeb480